import { j as t } from "../../../jsx-runtime-p91LotPX.mjs";
import { GrowCheckBox as G } from "../../CheckBox/AntCheckBox.js";
import { u as V, t as $ } from "../../../table-XsUAem3c.mjs";
import { GrowFlex as w } from "../../Flex/Flex.js";
import { Tags as z } from "../../Tag/AntTag.js";
import { ArrowIcon as K } from "../../../Icons/Icons.js";
import { P as M } from "../../../GrowAvatar-DJSlhesM.mjs";
import { GrowButton as J } from "../../Button/AntButton.js";
import "../../Typography/AntTypography.js";
import "../../utils/datetime-formatter.js";
import "../../../core.esm-D9FG3ApV.mjs";
import "../../../SortableItem-C--6XTJo.mjs";
import "../../../lodash-lyheMOjd.mjs";
import { useState as k, useRef as N, useEffect as P, useMemo as U, cloneElement as X } from "react";
import "../../Dnd/SortableContainer.js";
import "../../../AntDrawer-ChgesM8B.mjs";
import "../../../style-BCs5tvAM.mjs";
import "../../StatusTag/style.js";
import "../../../main-C3-4ZYQP.mjs";
import "../ColumnCustom/ColumnSort/ColumnSortList.js";
import { useSorter as R } from "./useSorter.js";
import "../BulkAction/style.js";
import "../Pagination/style.js";
import "../style.js";
import "../../Tree/style.js";
import "../../UI/FormArea/FormFooter.js";
import "../../css.js";
import { headerActions as E } from "./perdicate.js";
import { D as Y } from "../../../index-CgEpbOWw.mjs";
import { I as Z } from "../../../index-Dp_V09On.mjs";
function q(e) {
  const {
    text: o,
    styles: c
  } = e;
  return /* @__PURE__ */ t.jsx("span", { className: "ag-header-cell-text", style: {
    ...c
  }, children: o });
}
function y(e) {
  const {
    hide: o,
    mode: c,
    iconStyles: i
  } = e;
  if (o)
    return null;
  const a = c === "asc" ? "ag-sort-ascending-icon" : c === "desc" ? "ag-sort-descending-icon" : "ag-sort-icon-none", d = c === "asc" ? "ag-icon-asc" : c === "desc" ? "ag-icon-desc" : "ag-icon-none";
  return /* @__PURE__ */ t.jsx("span", { className: `ag-sort-indicator-icon ${a}`, "aria-hidden": "true", children: /* @__PURE__ */ t.jsx("span", { className: `ag-icon ${d}`, role: "presentation", style: {
    color: "var(--gray-7)",
    ...i
  } }) });
}
function v(e) {
  return /* @__PURE__ */ t.jsx("div", { className: "ag-header-cell-label", onClick: (o) => {
    o.stopPropagation(), o.preventDefault(), e.onSort();
  }, style: {
    cursor: "pointer",
    ...e.styles
  }, children: e.children });
}
function ee(e) {
  const {
    headerStyles: o,
    headerTextColor: c,
    enableSorting: i,
    iconStyles: a
  } = e, {
    onSort: d,
    currentSort: s
  } = R({
    columnApi: e.columnApi,
    colId: e.column.getColId(),
    currentSort: e.column.getSort(),
    api: e.api
  });
  return /* @__PURE__ */ t.jsxs(v, { onSort: () => {
    i && (d(), e.progressSort());
  }, styles: o, children: [
    /* @__PURE__ */ t.jsx(q, { text: e.displayName, styles: c }),
    i && /* @__PURE__ */ t.jsx(y, { mode: "unsorted", hide: !!s, iconStyles: a }),
    i && s ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(y, { mode: "asc", hide: s === "desc", iconStyles: a }),
      /* @__PURE__ */ t.jsx(y, { mode: "desc", hide: s === "asc", iconStyles: a })
    ] }) : null
  ] });
}
function H(e) {
  const {
    api: o,
    context: c,
    bulkRecords: i,
    headerStyles: a
  } = e, [d, s] = k(!1), m = V($), j = c.table, h = N(null), S = i || (j ? j.bulk_records : m.bulk_records), [b, g] = k(!1), u = m.selectAll.select_all, [C, f] = k(!1);
  function A() {
    const r = [];
    return o.forEachNode((l) => {
      r.push(l);
    }), r;
  }
  const x = A();
  function n() {
    const r = (l) => {
      const p = l.api.getSelectedRows().length, B = l.api.getRenderedNodes().length;
      if (u && p) {
        g(!1), s(!0), f(!1);
        return;
      }
      if (l.source === "apiSelectAll" || l.source === "uiSelectAllFiltered") {
        g(!1), s(!!p), f(!1);
        return;
      }
      if (l.source === "checkboxSelected") {
        const I = p === B;
        g(!I && !!p), s(I), f(!1);
        return;
      }
      if (l.source === "rowDataChanged" || l.source === "api") {
        f(!0);
        return;
      }
    };
    return o.addEventListener("rowSelected", r), () => {
      o.removeEventListener("rowSelected", r);
    };
  }
  function F() {
    if (!C)
      return;
    const r = o.getSelectedNodes().filter((p) => x.some((B) => B.id === p.id)), l = r.length === x.length;
    s(l), g(!l && r.length > 0);
  }
  P(F, [o, C, x]), P(n, [o, u]);
  const L = U(() => u || d, [u, d]), T = u ? !1 : b;
  function Q(r) {
    r.key === "SELECT_ALL" ? o.selectAll("apiSelectAll") : o.deselectAll("apiSelectAll");
  }
  function D(r) {
    const l = o.getQuickFilter();
    r.target.checked ? l ? o.selectAllFiltered("uiSelectAllFiltered") : o.selectAll("uiSelectAll") : o.deselectAll("uiSelectAll"), s(r.target.checked), g(!1);
  }
  function _() {
    var r;
    return u ? (r = E) == null ? void 0 : r.filter((l) => (l == null ? void 0 : l.key) !== "SELECT_ALL") : E;
  }
  const O = _(), W = /* @__PURE__ */ t.jsx(G, { checked: L, indeterminate: T, onChange: D, design: "border-design" });
  return /* @__PURE__ */ t.jsxs(w, { align: "center", space: "8", style: a, children: [
    W,
    S && S <= 200 ? /* @__PURE__ */ t.jsx(Y, { menu: {
      items: O,
      onClick: Q,
      getPopupContainer() {
        return h.current;
      }
    }, placement: "bottomRight", children: /* @__PURE__ */ t.jsx("div", { ref: h, children: /* @__PURE__ */ t.jsx(K, {}) }) }) : null
  ] });
}
function te(e) {
  var C, f, A, x;
  const [o, c] = k(), [i, a] = k(!1), [d, s] = k(!1), m = N(null), {
    onSort: j,
    currentSort: h
  } = R({
    columnApi: e.columnApi,
    colId: e.column.getColId(),
    currentSort: e.column.getSort(),
    api: e.api
  }), S = (C = e.quickFilter) != null && C.filterComponent ? X(e.quickFilter.filterComponent, {
    ...e,
    quickFilter: {
      ...e.quickFilter,
      getFilterValue: (n) => {
        c(n);
      },
      onClose() {
        a(!1);
      }
    }
  }) : null, b = /* @__PURE__ */ t.jsx(Z, { ref: m, allowClear: {
    clearIcon: (f = e.quickFilter) == null ? void 0 : f.clearIcon
  }, value: o, onChange: (n) => {
    n.stopPropagation(), c(n.target.value), e.api.setQuickFilter(n.target.value);
  }, placeholder: ((A = e.quickFilter) == null ? void 0 : A.placeholderText) ?? "Search", onClick: (n) => {
    n.stopPropagation();
  }, onKeyDown: (n) => {
    n.key === "Enter" ? s(!0) : s(!1);
  } }), g = /* @__PURE__ */ t.jsx(M, { placement: "bottomLeft", trigger: ["click"], open: S ? i : void 0, content: S || b, showArrow: !1, getPopupContainer: () => document.querySelector(".ag-root"), onOpenChange: (n) => {
    a(n);
  }, destroyTooltipOnHide: !0, children: /* @__PURE__ */ t.jsx(J, { icon: (x = e.quickFilter) == null ? void 0 : x.filterIcon, iconButton: "without_bg", size: "small", onClick: (n) => {
    var F;
    n.stopPropagation(), a(!i), (F = m == null ? void 0 : m.current) == null || F.focus();
  }, style: {
    display: "flex",
    alignItems: "center"
  } }) }), u = /* @__PURE__ */ t.jsx(t.Fragment, { children: d ? /* @__PURE__ */ t.jsx(z, { closable: !0, onClose: (n) => {
    n.stopPropagation(), c(void 0), e.api.setQuickFilter(""), e.api.deselectAll("uiSelectAll");
  }, style: {
    display: "flex",
    alignItems: "center"
  }, children: o }) : null });
  return /* @__PURE__ */ t.jsxs(w, { align: "center", space: "8", children: [
    /* @__PURE__ */ t.jsxs(v, { onSort: () => {
      e.enableSorting && (j(), e.progressSort());
    }, styles: {
      gap: "var(--space-2)"
    }, children: [
      /* @__PURE__ */ t.jsx(q, { text: e.displayName, styles: {
        ...e.headerTextColor
      } }),
      o ? u : null,
      e.enableSorting && /* @__PURE__ */ t.jsx(y, { mode: "unsorted", hide: !!h, iconStyles: {
        ...e.iconStyles
      } }),
      e.enableSorting && h ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx(y, { mode: "asc", hide: h === "desc", iconStyles: {
          ...e.iconStyles
        } }),
        /* @__PURE__ */ t.jsx(y, { mode: "desc", hide: h === "asc", iconStyles: {
          ...e.iconStyles
        } })
      ] }) : null
    ] }),
    g
  ] });
}
function Re(e) {
  return /* @__PURE__ */ t.jsxs(w, { align: "center", space: "2", children: [
    /* @__PURE__ */ t.jsx(H, { headerStyles: {
      width: "40px"
    }, ...e }),
    /* @__PURE__ */ t.jsx(ee, { ...e })
  ] });
}
function qe(e) {
  return /* @__PURE__ */ t.jsxs(w, { align: "center", space: "2", children: [
    /* @__PURE__ */ t.jsx(H, { headerStyles: {
      width: "40px"
    }, ...e }),
    /* @__PURE__ */ t.jsx(te, { ...e })
  ] });
}
export {
  ee as DefaultHeaderComponents,
  H as HeaderCheckBoxSelection,
  q as HeaderText,
  Re as HeaderWithCheckBox,
  qe as HeaderWithCheckBoxWithQuickFilter,
  te as HeaderWithQuickFilter,
  v as HeaderWrapper,
  y as SortIcon
};
//# sourceMappingURL=DefaultHeaderComponents.js.map
